// src/admin/pages/errors/AdminNetworkErrorPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminNetworkErrorPage() {
  const navigate = useNavigate();
  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <h1 className="mb-3">Network Error</h1>
      <p className="text-muted mb-4">We couldn’t reach the server. Please check your connection and try again.</p>
      <button className="btn btn-primary" onClick={() => navigate('/admin/dashboard')}>
        Go back to dashboard
      </button>
    </div>
  );
}